import { useContext } from 'react';
import { MultistepStateContext } from '../Context.js';

function useMultistepState() {
  return useContext(MultistepStateContext);
}

export { useMultistepState };
